import apiClient from './client';

export interface ChurchDirectoryProfile {
  id: number;
  churchName: string;
  contactName?: string | null;
  contactPosition?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  city?: string | null;
  state?: string | null;
  addressStreet?: string | null;
  addressStreet2?: string | null;
  addressCity?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
  addressCountry?: string | null;
  denomination?: string | null;
  website?: string | null;
  notes?: string | null;
  churchPlanterId?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertChurchDirectoryProfileData {
  churchName: string;
  contactName?: string;
  contactPosition?: string;
  contactPhone?: string;
  contactEmail?: string;
  city?: string;
  state?: string;
  addressStreet?: string;
  addressStreet2?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
  addressCountry?: string;
  denomination?: string;
  website?: string;
  notes?: string;
}

class ChurchDirectoryService {
  async getMyChurchProfile(): Promise<ChurchDirectoryProfile> {
    const response = await apiClient.get('/church-directory/me');
    return response.data.data;
  }

  async upsertMyChurchProfile(data: UpsertChurchDirectoryProfileData): Promise<ChurchDirectoryProfile> {
    const response = await apiClient.put('/church-directory/me', data);
    return response.data.data;
  }
}

export const churchDirectoryService = new ChurchDirectoryService();
